<template>
  <div class="tile is-ancestor">
    <div v-for="(fi, fiIndex) in foodItems" :key="fi.id" class="tile is-parent">
      <div class="tile is-child article notification" :class="tileColor(fiIndex)">
        <p class="title">
        <a role="button" style="text-decoration: none" class="is-size-4-mobile" @click="routeFoodItem(fi)">{{fi.name}}</a>
          <a v-if="fi.link" :href="fi.link" target="_blank">
            <span class="icon">
              <font-awesome-icon v-if="youTubeLink(fi.link)" :icon="['fab', 'youtube']" />
              <font-awesome-icon v-else icon="external-link-alt" />
            </span>
          </a>
        </p>
        <p class="subtitle">
          <a v-if="fi.address && fi.address.city" :href="addrHref(fi)" target="_blank">{{fi.address.city}}</a>
          <template v-else-if="fi.address">{{addrString(fi.address)}}</template>
          <template v-else>&nbsp;</template>
        </p>
        <p>
          <span class="icon">
            <b-icon size="is-small" :icon="typeIcon(fi.type)" />
          </span>
          <span class="icon">
            <b-icon size="is-small" :icon="accessIcon(fi.access)" />
          </span>
        </p>
        <div v-if="fi.categories" class="tags tag-list">
          <span
            v-for="c in fi.categories"
            :key="c"
            class="tag tag-border"
            :class="tileColor(fiIndex)">{{c}}
          </span>
        </div>
        <p>{{fi.description}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import BrowseMixin from './BrowseMixin';

const tileColors = ['is-info', 'is-primary', 'is-warning', 'is-danger', 'is-link', 'is-success'];

export default {
  name: 'browse-tiles',
  mixins: [BrowseMixin],
  methods: {
    tileColor(index) {
      return tileColors[Math.floor(index % tileColors.length)];
    },
  },
};
</script>

<style lang="sass">

div.is-ancestor
  flex-wrap: wrap

div.is-child
  min-width: 20rem

div>p>a.is-text
  text-decoration: none

div>p>a.is-text:hover
  text-decoration: underline

.tag-border
  border-color: #0000004d
  border-style: solid
  border-width: 1px

.tag-list
  padding-top: 1rem

</style>



// WEBPACK FOOTER //
// src/components/browse/BrowseTiles.vue